/* Solkit Monteringskonfigurator — SOL-925
 * Bygget fra Configurator/index.html + products-config.js (SOL-7).
 *
 * VIGTIGT: ingen priser og ingen variant-ID'er er hardkodede her.
 * Hver komponent kender kun sit SKU. Ved sideindlaesning hentes
 * /products.json (offentligt, ingen auth) og SKU'erne slaas op mod
 * det levende katalog, saa pris, variant-ID, lagerstatus og produktnavn
 * altid kommer fra butikken.
 */
var SHOPIFY_DOMAIN = 'shop.solkit.dk';

var COMPONENTS = {
  rail_4200: { name: "Monteringsskinne R52 4,2 m", sku: "SK-R52-4200", unit: 'stk', variantId: null, price: 0 },
  rail_2400: { name: "Monteringsskinne R52 2,4 m", sku: "SK-R52-2400", unit: 'stk', variantId: null, price: 0 },
  rail_splice: { name: "Skinnesamler R52", sku: "SK-SFR-01", unit: 'stk', variantId: null, price: 0 },
  mid_clamp: { name: "Mellemklemme 30-40 mm", sku: "SK-AIC", unit: 'stk', variantId: null, price: 0 },
  end_clamp: { name: "Endeklemme 30-35 mm", sku: "SK-AEC", unit: 'stk', variantId: null, price: 0 },
  grounding_lug: { name: "Jordingsplade / potentialudligning", sku: "SK-GEL", unit: 'stk', variantId: null, price: 0 },
  grounding_clip: { name: "Jordingsplade (pr. panel)", sku: "SK-GEL", unit: 'stk', variantId: null, price: 0 },
  cable_clip_2: { name: "Kabelclips 3-5/20 mm (100 stk.)", sku: "SK-Clips-3-5-Flad", unit: 'stk', variantId: null, price: 0 },
  cable_clip_4: { name: "Kabelclips 5-7/20 mm (100 stk.)", sku: "SK-KAB-006", unit: 'stk', variantId: null, price: 0 },
  ballast_front_leg: { name: "Ballast forben 10°", sku: "SK-BS2-F10", unit: 'stk', variantId: null, price: 0 },
  ballast_back_leg: { name: "Ballast bagben PRO 10°", sku: "SK-BS2-B10", unit: 'stk', variantId: null, price: 0 },
  ballast_rail_r41_2: { name: "Monteringsskinne R41-2 2,4 m", sku: "SK-R41-2-2400", unit: 'stk', variantId: null, price: 0 },
  ballast_rail_r41_2_splice: { name: "Skinnesamler R41-2", sku: "SK-SFR-R41-2", unit: 'stk', variantId: null, price: 0 },
  ballast_t_bolt: { name: "M8x70 bolt", sku: "SK-M8X70", unit: 'stk', variantId: null, price: 0 },
  ballast_tray: { name: "Ballastbakke", sku: "SK-BS2-BT", unit: 'stk', variantId: null, price: 0 },
  tile_hook_universal: { name: "Tagkrog til tagsten – komplet sæt", sku: "SK-TRH-T01", unit: 'stk', variantId: null, price: 0 },
  tile_hook_spanish: { name: "Tagkrog 90° drejelig", sku: "SK-TRH-T03", unit: 'stk', variantId: null, price: 0 },
  roof_rail_r52: { name: "Monteringsskinne R52 4,2 m", sku: "SK-R52-4200", unit: 'stk', variantId: null, price: 0 },
  roof_rail_r52_splice: { name: "Skinnesamler R52", sku: "SK-SFR-01", unit: 'stk', variantId: null, price: 0 },
  hanger_bolt: { name: "Ansatsskrue / hængebolt M10x200", sku: "SK-D03-M10X200", unit: 'stk', variantId: null, price: 0 },
  l_foot: { name: "L-fod til bølge-/trapezplade", sku: "SK-TRB-D01", unit: 'stk', variantId: null, price: 0 },
  ground_screw: { name: "Jordskrue 1,6 m", sku: "SK-GF1-1600", unit: 'stk', variantId: null, price: 0 },
  ground_bracket: { name: "H-bærebeslag til jordstativ", sku: "SK-CPH-01", unit: 'stk', variantId: null, price: 0 },
  ground_rail_connector: { name: "Skinnesamler R80", sku: "SK-SFR-R80", unit: 'stk', variantId: null, price: 0 },
};

var PANELS = [
  { id: "rosen-560-fb", sku: "SK-Rosen Half Cell PERC Panel", name: "SK-Rosen Half Cell PERC Panel", brand: "Rosen", wattage: 560, width_mm: 1134, height_mm: 2279, variantId: null, price: 0 },
  { id: "rosen-560-allblack", sku: "SK-Rosen panel -sort 560W", name: "SK-Rosen panel -sort 560W", brand: "Rosen", wattage: 560, width_mm: 1134, height_mm: 2279, variantId: null, price: 0 },
  { id: "rosen-560-silver", sku: "SK-PAN-002", name: "SK-PAN-002", brand: "Rosen", wattage: 560, width_mm: 1134, height_mm: 2279, variantId: null, price: 0 },
  { id: "rosen-560-bifacial", sku: "SK-PAN-003", name: "SK-PAN-003", brand: "Rosen", wattage: 560, width_mm: 1134, height_mm: 2279, variantId: null, price: 0 },
  { id: "jinko-415-1000v", sku: "SK-Jinko JKM415N-54HL4-B", name: "SK-Jinko JKM415N-54HL4-B", brand: "Jinko", wattage: 415, width_mm: 1134, height_mm: 1722, variantId: null, price: 0 },
  { id: "jinko-465-bf", sku: "SK-PAN-004", name: "SK-PAN-004", brand: "Jinko", wattage: 465, width_mm: 1134, height_mm: 1903, variantId: null, price: 0 },
];

/* ---- Live-opslag mod /products.json (zero-auth) ---------------------- */
var CATALOG_READY = false;
var CATALOG_ERROR = null;

function skonfBuildIndex(products) {
  var idx = {};
  for (var i = 0; i < products.length; i++) {
    var p = products[i];
    for (var j = 0; j < p.variants.length; j++) {
      var v = p.variants[j];
      var sku = (v.sku || '').trim();
      if (!sku) continue;
      // foerste traeffer vinder, men en vare paa lager slaar en udsolgt
      if (!idx[sku] || (v.available && !idx[sku].available)) {
        idx[sku] = {
          variantId: v.id,
          price: parseFloat(v.price),
          available: !!v.available,
          productTitle: p.title,
          variantTitle: v.title,
          handle: p.handle
        };
      }
    }
  }
  return idx;
}

function skonfApplyCatalog(idx) {
  var missing = [];
  var k;
  for (k in COMPONENTS) {
    if (!COMPONENTS.hasOwnProperty(k)) continue;
    var hit = idx[COMPONENTS[k].sku];
    if (hit) {
      COMPONENTS[k].variantId = hit.variantId;
      COMPONENTS[k].price = hit.price;
      COMPONENTS[k].available = hit.available;
      COMPONENTS[k].handle = hit.handle;
    } else {
      missing.push(COMPONENTS[k].sku);
    }
  }
  var live = [];
  for (var i = 0; i < PANELS.length; i++) {
    var ph = idx[PANELS[i].sku];
    if (ph) {
      PANELS[i].variantId = ph.variantId;
      PANELS[i].price = ph.price;
      PANELS[i].available = ph.available;
      PANELS[i].handle = ph.handle;
      PANELS[i].name = ph.productTitle;   // navn fra butikken, ikke fra denne fil
      live.push(PANELS[i]);
    } else {
      missing.push(PANELS[i].sku);
    }
  }
  PANELS = live;
  if (missing.length) {
    if (window.console) console.warn('[konfigurator] SKU ikke fundet i /products.json:', missing);
  }
  return missing;
}

function skonfLoadCatalog() {
  return fetch('/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
    .then(function (r) {
      if (!r.ok) throw new Error('products.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (d) {
      var products = d.products || [];
      if (!products.length) throw new Error('products.json var tom');
      skonfApplyCatalog(skonfBuildIndex(products));
      CATALOG_READY = true;
    })
    .catch(function (e) {
      CATALOG_ERROR = e.message || String(e);
      if (window.console) console.error('[konfigurator] kunne ikke hente katalog:', e);
    });
}

// ─── State ──────────────────────────────────────────────────────────────────
let state = {
  currentStep: 1,
  roofType: null,
  fields: [],
  panel: null,
};

// ─── Roof type definitions ──────────────────────────────────────────────────
const ROOF_TYPES = [
  {
    id: 'flat_ballast',
    label: 'Fladt tag',
    sublabel: 'Ballastsystem',
    icon: '🏢',
    desc: 'Fladt betonunderlag med ballastmonterede stativer',
  },
  {
    id: 'tile',
    label: 'Tegltag',
    sublabel: 'Teglkrog + skinne',
    icon: '🏠',
    desc: 'Klassisk tegltag – kroge monteres under tagsten',
  },
  {
    id: 'eternit',
    label: 'Eternittag',
    sublabel: 'Hængebolt + skinne',
    icon: '🏗️',
    desc: 'Bølgeeternitplader – hængebolt i undertag',
  },
  {
    id: 'metal',
    label: 'Metaltag',
    sublabel: 'Trapezblik / L-fod',
    icon: '🏭',
    desc: 'Trapezblik eller stålplader – L-fødder i trapez',
  },
  {
    id: 'ground',
    label: 'Jordmonteret',
    sublabel: 'Jordskrue + beslag',
    icon: '🌱',
    desc: 'Monteret direkte i jord med spiralskruer',
  },
];

// ─── Component calculation logic ───────────────────────────────────────────
function calcBOM(roofType, fields, panel) {
  const bom = {}; // { componentKey: qty }

  function add(key, qty) {
    if (qty <= 0) return;
    bom[key] = (bom[key] || 0) + Math.ceil(qty);
  }

  let totalPanels = 0;

  fields.forEach(field => {
    const pw = field.orientation === 'portrait' ? panel.width_mm : panel.height_mm;
    const ph = field.orientation === 'portrait' ? panel.height_mm : panel.width_mm;

    const panelsX = Math.floor((field.width * 1000) / (pw + 10)); // 10mm gap
    const panelsY = Math.floor((field.height * 1000) / (ph + 10));
    const n = Math.max(1, panelsX) * Math.max(1, panelsY);
    const rows = Math.max(1, panelsY);
    const perRow = Math.max(1, panelsX);

    totalPanels += n;

    // Row length in mm for rail calculations
    const rowLengthMm = perRow * pw + (perRow - 1) * 17 + 2 * 20.5 + 20 + 60;

    // Rails needed per row (using 4200mm rails, 2 rails per row: top + bottom)
    const railsPerSide = Math.ceil(rowLengthMm / 4200);
    const totalRails = railsPerSide * 2 * rows;
    const splicesPerSide = Math.max(0, railsPerSide - 1);
    const totalSplices = splicesPerSide * 2 * rows;

    // Clamps
    const midClamps = (perRow - 1) * rows;
    const endClamps = 2 * rows;

    // Grounding (1 per row per side)
    const groundingLugs = rows * 2;
    const groundingClips = n; // 1 per panel

    if (roofType === 'flat_ballast') {
      // Ballast-specific: bottom rail units cover 2 panels each
      const unitsPerRow = Math.ceil(perRow / 2);
      const totalUnits = unitsPerRow * rows;
      add('ballast_rail_r41_2', totalUnits);
      add('ballast_front_leg', totalUnits * 2);
      add('ballast_back_leg', totalUnits * 2);
      add('ballast_t_bolt', totalUnits * 4);
      add('ballast_tray', totalUnits * 2); // 1 tray per front leg
      add('ballast_rail_r41_2_splice', Math.max(0, unitsPerRow - 1) * rows); // splices for long rows
      add('mid_clamp', midClamps);
      add('end_clamp', endClamps);
      add('grounding_lug', groundingLugs);
      add('grounding_clip', groundingClips);
      add('cable_clip_4', Math.ceil(n / 4));

    } else if (roofType === 'tile') {
      add('roof_rail_r52', totalRails);
      add('roof_rail_r52_splice', totalSplices);
      // Tile hooks: 4 per module (2 per rail × 2 rails per module row)
      // Actually: hooks per row = railsPerSide + 1 attachment points, but simplified:
      // ~2 hooks per 1200mm of rail length, so total hooks ≈ (rowLengthMm / 600) * 2 * rows
      const hooksPerRow = Math.ceil(rowLengthMm / 600) * 2;
      add('tile_hook_universal', hooksPerRow * rows);
      add('mid_clamp', midClamps);
      add('end_clamp', endClamps);
      add('grounding_lug', groundingLugs);
      add('grounding_clip', groundingClips);
      add('cable_clip_4', Math.ceil(n / 4));

    } else if (roofType === 'eternit') {
      add('roof_rail_r52', totalRails);
      add('roof_rail_r52_splice', totalSplices);
      // Hanger bolts: same spacing logic as L feet
      const boltsPerRow = Math.ceil(rowLengthMm / 800) * 2; // ~800mm spacing
      add('hanger_bolt', boltsPerRow * rows);
      add('mid_clamp', midClamps);
      add('end_clamp', endClamps);
      add('grounding_lug', groundingLugs);
      add('grounding_clip', groundingClips);
      add('cable_clip_4', Math.ceil(n / 4));

    } else if (roofType === 'metal') {
      add('rail_4200', totalRails);
      add('rail_splice', totalSplices);
      // L feet: ~800mm spacing along rail
      const feetPerRow = Math.ceil(rowLengthMm / 800) * 2;
      add('l_foot', feetPerRow * rows);
      add('mid_clamp', midClamps);
      add('end_clamp', endClamps);
      add('grounding_lug', groundingLugs);
      add('grounding_clip', groundingClips);
      add('cable_clip_4', Math.ceil(n / 4));

    } else if (roofType === 'ground') {
      // Ground mount: 2 screws per module-pair column, rails per row
      add('rail_4200', totalRails);
      add('rail_splice', totalSplices);
      add('ground_screw', Math.ceil(perRow / 2 + 1) * rows * 2); // front + back per structure
      add('ground_bracket', Math.ceil(perRow / 2) * rows);
      add('ground_rail_connector', totalSplices);
      add('mid_clamp', midClamps);
      add('end_clamp', endClamps);
      add('grounding_lug', groundingLugs);
      add('grounding_clip', groundingClips);
      add('cable_clip_4', Math.ceil(n / 4));
    }
  });

  // Always add panel itself
  add('__panel__', totalPanels);

  return { bom, totalPanels };
}

// ─── Render helpers ─────────────────────────────────────────────────────────
function fmt(n) {
  return new Intl.NumberFormat('da-DK', { minimumFractionDigits: 2 }).format(n);
}

function renderRoofGrid() {
  const grid = document.getElementById('roofGrid');
  grid.innerHTML = ROOF_TYPES.map(rt => `
    <div class="roof-option ${state.roofType === rt.id ? 'selected' : ''}"
         onclick="selectRoof('${rt.id}')">
      <span class="icon">${rt.icon}</span>
      <div class="label">${rt.label}</div>
      <div class="sublabel">${rt.sublabel}</div>
    </div>
  `).join('');
}

function selectRoof(id) {
  state.roofType = id;
  renderRoofGrid();
  document.getElementById('btn1next').disabled = false;
}

// ─── Fields ─────────────────────────────────────────────────────────────────
function addField() {
  if (state.fields.length >= 6) return;
  state.fields.push({ width: 5, height: 8, pitch: 25, orientation: 'portrait' });
  renderFields();
  if (state.fields.length >= 6) document.getElementById('btnAddField').disabled = true;
}

function removeField(i) {
  state.fields.splice(i, 1);
  renderFields();
  document.getElementById('btnAddField').disabled = false;
}

function updateField(i, key, value) {
  state.fields[i][key] = key === 'orientation' ? value : parseFloat(value) || 0;
  renderFieldSummary(i);
}

function renderFieldSummary(i) {
  const field = state.fields[i];
  const panel = state.panel;
  const el = document.getElementById('summary_' + i);
  if (!el) return;
  if (panel) {
    const pw = field.orientation === 'portrait' ? panel.width_mm : panel.height_mm;
    const ph = field.orientation === 'portrait' ? panel.height_mm : panel.width_mm;
    const pX = Math.floor((field.width * 1000) / (pw + 10));
    const pY = Math.floor((field.height * 1000) / (ph + 10));
    const n = Math.max(0, pX) * Math.max(0, pY);
    el.textContent = `→ ${pX || 0} × ${pY || 0} paneler = ${n} paneler (${(n * panel.wattage / 1000).toFixed(1)} kWp)`;
  } else {
    el.textContent = `${field.width}m × ${field.height}m, hæld. ${field.pitch}°`;
  }
}

function renderFields() {
  const list = document.getElementById('fieldsList');
  if (state.fields.length === 0) {
    list.innerHTML = `<div style="text-align:center;padding:20px;color:var(--muted);font-size:0.85rem;">
      Ingen tagfelter endnu — klik "+ Tilføj tagfelt"
    </div>`;
    return;
  }
  list.innerHTML = state.fields.map((f, i) => `
    <div class="field-card">
      <div class="field-header">
        <span class="field-title">Tagfelt ${i + 1}</span>
        <button class="btn-remove" onclick="removeField(${i})" title="Fjern felt">✕</button>
      </div>
      <div class="field-row">
        <div class="field-group">
          <label>Bredde (m)</label>
          <input type="number" min="0.5" max="100" step="0.1" value="${f.width}"
            oninput="updateField(${i},'width',this.value)">
        </div>
        <div class="field-group">
          <label>Længde (m)</label>
          <input type="number" min="0.5" max="100" step="0.1" value="${f.height}"
            oninput="updateField(${i},'height',this.value)">
        </div>
        <div class="field-group">
          <label>Taghældning (°)</label>
          <input type="number" min="0" max="60" step="1" value="${f.pitch}"
            oninput="updateField(${i},'pitch',this.value)">
        </div>
        <div class="field-group">
          <label>Panelretning</label>
          <div class="orient-toggle">
            <input type="radio" name="orient_${i}" id="portrait_${i}" value="portrait"
              ${f.orientation === 'portrait' ? 'checked' : ''}
              onchange="updateField(${i},'orientation','portrait')">
            <label for="portrait_${i}">Portrait</label>
            <input type="radio" name="orient_${i}" id="landscape_${i}" value="landscape"
              ${f.orientation === 'landscape' ? 'checked' : ''}
              onchange="updateField(${i},'orientation','landscape')">
            <label for="landscape_${i}">Landscape</label>
          </div>
        </div>
      </div>
      <div class="field-summary" id="summary_${i}">—</div>
    </div>
  `).join('');
  state.fields.forEach((_, i) => renderFieldSummary(i));
}

// ─── Panels ──────────────────────────────────────────────────────────────────
/* ---- Lagerbevidsthed (SOL-925, CEO 2026-09-13) --------------------------
   window.SKONF_STOCK renderes fra Liquid i templates/page.konfigurator.liquid,
   fordi hverken /products.json eller /products/<handle>.js baerer
   inventory_quantity. Mangler kortet, degraderer alt herunder til "ingen
   lagerinfo" - aldrig til en fejl. ---------------------------------------- */
function skonfStock(sku) {
  var map = window.SKONF_STOCK;
  if (!map || !sku) return null;
  var e = map[sku];
  if (!e || typeof e.qty !== 'number') return null;
  return { qty: e.qty, policy: e.policy === 'continue' ? 'continue' : 'deny', tracked: e.tracked !== false };
}

function skonfStockNote(p) {
  var s = skonfStock(p.sku);
  if (!s || !s.tracked) return '';
  var css = 'display:inline-block;margin-top:4px;font-size:0.74rem;font-weight:600;padding:2px 8px;border-radius:10px;';
  if (s.qty <= 0) {
    return s.policy === 'deny'
      ? '<span style="' + css + 'background:#fdecea;color:#8f1d14;">Udsolgt \u2013 kan ikke bestilles</span>'
      : '<span style="' + css + 'background:#fff5e5;color:#8a5a00;">Ikke paa lager \u2013 leveres paa bestilling</span>';
  }
  if (s.policy === 'deny' && s.qty <= 10)
    return '<span style="' + css + 'background:#fff5e5;color:#8a5a00;">Kun ' + s.qty + ' stk. paa lager</span>';
  if (s.policy === 'deny')
    return '<span style="' + css + 'background:#e8f5ec;color:#1d6b38;">' + s.qty + ' stk. paa lager</span>';
  if (s.qty <= 3)
    return '<span style="' + css + 'background:#fff5e5;color:#8a5a00;">' + s.qty + ' stk. paa lager \u2013 resten leveres paa bestilling</span>';
  return '<span style="' + css + 'background:#e8f5ec;color:#1d6b38;">' + s.qty + ' stk. paa lager</span>';
}

function renderPanelList() {
  const list = document.getElementById('panelList');
  if (!PANELS || PANELS.length === 0) {
    list.innerHTML = `<div class="warning">Panelerne kunne ikke hentes fra butikken lige nu. Genindlaes siden, eller skriv til salg@solkit.dk.</div>`;
    return;
  }
  list.innerHTML = PANELS.map(p => `
    <div class="panel-option ${state.panel && state.panel.id === p.id ? 'selected' : ''}"
         onclick="selectPanel('${p.id}')">
      <span class="pw">${p.wattage}W</span>
      <div>
        <div class="pname">${p.name}</div>
        <div class="pdim">${p.width_mm} × ${p.height_mm} mm · ${p.brand}
          ${p.price > 0 ? ' · <strong>' + fmt(p.price) + ' kr.</strong>' : ''}
        </div>
        ${skonfStockNote(p)}
      </div>
    </div>
  `).join('');
}

function selectPanel(id) {
  state.panel = PANELS.find(p => p.id === id);
  renderPanelList();
  document.getElementById('btn3next').disabled = !state.panel;
  // Refresh field summaries with panel dims
  state.fields.forEach((_, i) => renderFieldSummary(i));
}

// ─── BOM rendering ───────────────────────────────────────────────────────────
function skonfBomStockWarning(panel, qty) {
  var s = skonfStock(panel.sku);
  if (!s || !s.tracked || qty <= s.qty) return '';
  if (s.policy === 'deny') {
    return '<div class="warning">\u26a0\ufe0f <strong>' + panel.name + '</strong>: kun ' + s.qty +
      ' stk. paa lager, styklisten kraever ' + qty + ' stk. Kurven kan ikke rumme hele antallet \u2013 ' +
      'vaelg et andet panel i trin 3, eller skriv til <a href="mailto:salg@solkit.dk">salg@solkit.dk</a>.</div>';
  }
  return '<div class="info">\u2139\ufe0f <strong>' + panel.name + '</strong>: ' +
    (s.qty > 0 ? s.qty + ' stk. er paa lager nu' : 'ingen paa lager nu') +
    ', styklisten kraever ' + qty + ' stk. Resten leveres paa bestilling \u2013 ' +
    'skriv til <a href="mailto:salg@solkit.dk">salg@solkit.dk</a> for leveringstid.</div>';
}

function renderBOM() {
  const out = document.getElementById('bomOutput');
  if (!state.roofType || state.fields.length === 0 || !state.panel) {
    out.innerHTML = `<div class="warning">Mangler input. Gå tilbage og udfyld alle trin.</div>`;
    return;
  }

  const { bom, totalPanels } = calcBOM(state.roofType, state.fields, state.panel);
  const roofLabel = ROOF_TYPES.find(r => r.id === state.roofType)?.label;

  const totalKwp = (totalPanels * state.panel.wattage / 1000).toFixed(2);
  const totalArea = state.fields.reduce((s, f) => s + f.width * f.height, 0).toFixed(1);

  let hasMissingPrices = false;
  let grandTotal = 0;

  // Panel rows
  const panelQty = bom['__panel__'] || 0;
  const panelPrice = state.panel.price || 0;
  if (panelPrice === 0) hasMissingPrices = true;
  grandTotal += panelQty * panelPrice;

  // Component rows
  const compKeys = Object.keys(bom).filter(k => k !== '__panel__');
  let compRows = '';
  compKeys.forEach(k => {
    const comp = COMPONENTS[k];
    if (!comp) return;
    const qty = bom[k];
    const price = comp.price || 0;
    if (price === 0) hasMissingPrices = true;
    grandTotal += qty * price;
    compRows += `
      <tr>
        <td>${comp.name}</td>
        <td class="qty">${qty} ${comp.unit}</td>
        <td class="price">${price > 0 ? fmt(qty * price) + ' kr.' : '<span class="price-missing">—</span>'}</td>
      </tr>`;
  });

  out.innerHTML = `
    <div class="summary-grid">
      <div class="summary-item"><label>Tagtype</label><div class="val">${roofLabel}</div></div>
      <div class="summary-item"><label>Antal paneler</label><div class="val">${totalPanels} stk</div></div>
      <div class="summary-item"><label>Samlet effekt</label><div class="val">${totalKwp} kWp</div></div>
      <div class="summary-item"><label>Samlet tagareal</label><div class="val">${totalArea} m²</div></div>
    </div>

    ${hasMissingPrices ? `<div class="warning">
      ⚠️ Et eller flere produkter kunne ikke hentes fra butikken, så totalen nedenfor er ufuldstændig.
      Styklisten og mængderne er korrekte. Skriv til <a href="mailto:salg@solkit.dk">salg@solkit.dk</a>, så giver vi en samlet pris.
    </div>` : ''}

    ${skonfBomStockWarning(state.panel, panelQty)}

    <div class="card">
      <div class="bom-section">
        <h3>Solpaneler</h3>
        <table>
          <thead><tr><th>Produkt</th><th>Antal</th><th class="price">Pris inkl. moms</th></tr></thead>
          <tbody>
            <tr>
              <td>${state.panel.name} (${state.panel.wattage}W)</td>
              <td class="qty">${panelQty} stk</td>
              <td class="price">${panelPrice > 0 ? fmt(panelQty * panelPrice) + ' kr.' : '<span class="price-missing">—</span>'}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="bom-section">
        <h3>Monteringskomponenter</h3>
        <table>
          <thead><tr><th>Komponent</th><th>Antal</th><th class="price">Pris inkl. moms</th></tr></thead>
          <tbody>
            ${compRows}
            <tr class="total-row">
              <td colspan="2">Samlet estimat</td>
              <td class="price">${grandTotal > 0 ? fmt(grandTotal) + ' kr.' : '<span class="price-missing">Priser mangler</span>'}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="info">
      💡 <strong>Styklisten er et estimat</strong> baseret på Enerack monteringsmanualernes standardberegninger.
      Endelige mængder bør verificeres af en montør før bestilling.
    </div>
  `;
}

// ─── Cart ────────────────────────────────────────────────────────────────────
function addToCart() {
  var res = calcBOM(state.roofType, state.fields, state.panel);
  var bom = res.bom;
  var merged = {};   // variantId -> qty  (samler dubletter, fx samme jordingsplade to gange)
  var skipped = [];

  var panelQty = bom['__panel__'] || 0;
  if (state.panel.variantId && panelQty > 0) {
    merged[state.panel.variantId] = (merged[state.panel.variantId] || 0) + panelQty;
  }

  Object.keys(bom).forEach(function (k) {
    if (k === '__panel__') return;
    var comp = COMPONENTS[k];
    if (!comp) return;
    if (!comp.variantId) { skipped.push(comp.name); return; }
    merged[comp.variantId] = (merged[comp.variantId] || 0) + bom[k];
  });

  var items = Object.keys(merged).map(function (id) {
    return { id: parseInt(id, 10), quantity: merged[id] };
  });

  if (items.length === 0) {
    alert('Styklisten kunne ikke laegges i kurven, fordi produkterne ikke kunne hentes fra butikken.\nProev at genindlaese siden.');
    return;
  }

  /* Pre-flight: et DENY-panel med for lidt lager giver ellers en haard 422 fra
     /cart/add.js, som addToCart() kaster videre som en blind fejlbesked. */
  var pStock = skonfStock(state.panel.sku);
  if (pStock && pStock.tracked && pStock.policy === 'deny' && panelQty > pStock.qty) {
    alert(state.panel.name + ': der er kun ' + pStock.qty + ' stk. paa lager, og din stykliste kraever '
      + panelQty + ' stk.\n\nVaelg et andet panel i trin 3, eller skriv til salg@solkit.dk '
      + '- saa skaffer vi resten og bestiller for dig.');
    return;
  }

  var btn = document.getElementById('btnCart');
  var label = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.innerHTML = 'Laegger i kurv...'; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  })
    .then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    })
    .then(function (out) {
      if (!out.ok) {
        throw new Error((out.data && (out.data.description || out.data.message)) || 'Ukendt fejl');
      }
      window.location.href = '/cart';
    })
    .catch(function (e) {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      alert('Kunne ikke laegge hele styklisten i kurven:\n' + (e.message || e) +
            '\n\nKontakt os paa salg@solkit.dk, saa klarer vi bestillingen manuelt.');
    });
}

function printBOM() {
  window.print();
}

// ─── Navigation ──────────────────────────────────────────────────────────────
function goTo(step) {
  // Validate forward nav
  if (step > 1 && !state.roofType) { goTo(1); return; }
  if (step > 2 && state.fields.length === 0) { goTo(2); return; }
  if (step > 3 && !state.panel) { goTo(3); return; }

  state.currentStep = step;

  document.querySelectorAll('.screen').forEach((s, i) => {
    s.classList.toggle('active', i + 1 === step);
  });

  document.querySelectorAll('.step').forEach((s, i) => {
    s.classList.remove('active', 'done');
    if (i + 1 === step) s.classList.add('active');
    else if (i + 1 < step) s.classList.add('done');
  });

  if (step === 4) renderBOM();
  if (step === 2) renderFields();
  if (step === 3) renderPanelList();
}

// ─── Init ────────────────────────────────────────────────────────────────────
function skonfInit() {
  renderRoofGrid();
  addField(); // Start med ét tagfelt
  var list = document.getElementById('panelList');
  if (list) list.innerHTML = '<div class="info">Henter produkter og priser fra butikken…</div>';

  skonfLoadCatalog().then(function () {
    if (CATALOG_ERROR) {
      var l = document.getElementById('panelList');
      if (l) l.innerHTML = '<div class="warning">Kunne ikke hente produkter fra butikken (' +
        CATALOG_ERROR + '). Genindlæs siden, eller skriv til ' +
        '<a href="mailto:salg@solkit.dk">salg@solkit.dk</a>.</div>';
      return;
    }
    if (state.currentStep === 3) renderPanelList();
    if (state.currentStep === 4) renderBOM();
    if (state.currentStep < 3) renderPanelList();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', skonfInit);
} else {
  skonfInit();
}